export enum TaskStatus {
  OPEN = "open",
  IN_PROGRESS = "in_progress",
  BLOCKED = "blocked",
  IN_REVIEW = "in_review",
  CLOSED = "closed",
}
